import { useInjection } from 'inversify-react';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { AddMarkingToolBl } from '../../AddMarkingTool.bl';
import { AddMarkingToolButton } from './AddMarkingToolButton';

export const AddMarkingToolButtonContainer = (): ReactElement => {
  const bl = useInjection(AddMarkingToolBl.$);

  const { projectId } = useParams<{ projectId: string }>();

  const handleShowModal = (): void => {
    bl.showModal(projectId);
  };

  return <AddMarkingToolButton onShowModal={handleShowModal} />;
};
